export default __webpack_public_path__ + "static/media/marker-default.00a0990a.svg";